import { gspx } from '@rsos/capstone';

export const trackADRPayload = (
  applicationName = '',
  irpVersion = '',
  messageType = '',
  locationPayloadID = '',
  locationRequestID = '',
  adrRequestID = '',
  adrPayloadID = '',
) => {
  const displayAppName = applicationName === 'capstone' ? 'RSP' : 'CSP';
  gspx.trackCustomEvent('ADR', {
    irpVersion,
    name: `ADR ${messageType} payload display in ${displayAppName}`,
    Category: 'ADR',
    'Launched date': new Date(),
    adrRequestID,
    adrPayloadID,
    locationPayloadID,
    locationRequestID,
  });
};
